/* eslint-disable no-restricted-exports */
// src/i18n.ts
import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: (
      JSON.parse(localStorage.getItem('selectedLanguage') || '{"code":"en"}') as { code: string }
    ).code,
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: './locales/{{lng}}/{{ns}}.json',
      allowMultiLoading: true,
    },
    ns: [
      'translation',
      'adminLogin',
      'apiError',
      'centerValidation',
      'courseMode',
      'fln',
      'instructions',
      'levelScreen',
      'ota',
      'stage',
      'studentLogin',
      'studentProfile',
      'task',
      'test',
    ],
    defaultNS: 'translation',
    react: {
      useSuspense: false,
    },
    load: 'languageOnly',
    cleanCode: true,
    nonExplicitSupportedLngs: true,
    // Add these options to improve loading behavior
    initImmediate: false,
    partialBundledLanguages: true,
    resources: {},
  });

export { default } from 'i18next';
